import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { featureTrackerAPI } from "redux/apis";
import { onClosePopUp } from "redux/slices";
import { Body, Container, Header, Title } from "./styles";

interface CGGEligibilityToolsProps {}

export const CGGEligibilityTools = ({}: CGGEligibilityToolsProps) => {
	const dispatch = useDispatch();
	const scale = useCalculateScale(363, 420);
	const { getImage } = useImagePath("cdn");
	const headImageUrl = getImage(
		clubGiftsGaloreAssets.v2.popups.shared.background
	);
	const titleUrl = getImage(clubGiftsGaloreAssets.v2.popups.shared.title);
	const { authToken } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const { data }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	const { tracker } = data ?? {};
	const activeTier = tracker?.tiers[tracker?.activeTierIndex];

	useEffect(() => {
		if (tracker) {
			reportEvent("hit_contribution_limit", {
				source: "club_gifts_galore",
				club_gifts_galore_id: tracker.clubGiftId,
				current_tier: tracker.activeTierIndex + 1,
				max_individual_contribution_limit: activeTier?.maxUserContributionCount
			});
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "hit_contribution_limit",
				event_type: "club_gift_galore_v2",
				action: "hit_contribution_limit",
				source: "club_gifts_galore",
				event_id: tracker?.id,
				confignodecount: activeTier?.maxUserContributionCount,
				loopcount: tracker?.activeTierIndex + 1
			});
		}
	}, []);

	if (!data?.tracker) {
		return null;
	}

	return (
		<Container scale={scale}>
			<Header data-image={headImageUrl}>
				<img src={titleUrl} alt="Club gifts galore" />
			</Header>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					Each member can
					<br /> contribute {activeTier?.maxUserContributionCount} per Tier.
				</Title>
				{/* <Text>
					If a Tier requires <strong>5 contributions</strong>,
					<br /> the Club must have at least <strong>5 members</strong>.
				</Text> */}
			</Body>
		</Container>
	);
};
